<div class="p-8">
  <div>
    <ciwc-order-custom-job
      [parentForm]="parentForm"
      [orderDetails]="orderDetails"
      [viewDisable]="viewDisable"
      [readonly]="readonlySpecFields"
      [itemProcesses]="itemProcesses"
      (caNumberSelected)="onCaNumberSelected($event)"
    ></ciwc-order-custom-job>
  </div>

  @if (viewDisable) {
    <ciwc-order-specification-display
      [parentForm]="parentForm"
      [details]="details"
      [orderDetails]="orderDetails"
    ></ciwc-order-specification-display>
  } @else {
    <ciwc-order-specification-builder
      [parentForm]="parentForm"
      [details]="details"
      [viewDisable]="viewDisable"
      [readonly]="readonlySpecFields"
      (requestChangeCa)="openChangeCaModal()"
    ></ciwc-order-specification-builder>
  }
</div>
